import { render, staticRenderFns } from "./OccupancyDetectorDevicePanel.vue?vue&type=template&id=297a1667&scoped=true&lang=pug&"
import script from "./OccupancyDetectorDevicePanel.vue?vue&type=script&lang=ts&"
export * from "./OccupancyDetectorDevicePanel.vue?vue&type=script&lang=ts&"
import style0 from "./OccupancyDetectorDevicePanel.vue?vue&type=style&index=0&id=297a1667&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a1667",
  null
  
)

export default component.exports